<template>
    <div id="app" ref="app" :class="[{ notScroll: isWeaponFilter || isSkinSort }]">
        <div class="MaskUpgradeVersionTemplate" @click="Upgrade" v-show="VersionInterceptionDisplay"></div>
        <div class="contentArea" v-if="needLogin">
            <transition name="fade">
                <div class="container">
                    <div class="loading" v-if="loading"></div>
                    <div class="topTips">目前仅支持生涯基础数据，单局战绩火速添加中</div>

                    <input type="text" v-model="account" placeholder="输入游戏昵称，如player#01" />
                    <div class="quickInput" v-if="accountList && accountList.length > 0">
                        <div class="label">账号快捷输入：</div>
                        <div class="accountList">
                            <span v-for="accountItem in accountList" @click="account = accountItem">{{ accountItem }}</span>
                        </div>
                    </div>
                    <div class="bindBtn" @click="bind()">立即绑定</div>
                    <div class="tips">当前仅限亚太服账号查询</div>
                </div>
            </transition>
        </div>
        <transition name="fade" v-else>
            <div class="mainArea">
                <div class="loading" v-if="loading"></div>
                <div class="loadingTxt" v-if="loading">
                    <span>数据加载中</span>
                    该过程视网络情况可能会持续数秒至数十秒若多次不成功,<br />可尝试在【设置-游戏账号管理】解绑后重新绑定
                </div>
                <div class="loadError" v-if="loadError">
                    <div class="dataErrorTips">当前账号数据加载失败！</div>
                    <div class="reloadDataBtn" @click="getInfo()">重新加载</div>
                </div>
                <div class="inquiryInfo" v-if="!loading && valorantTrackerInfo">
                    <!-- 顶部用户信息 -->
                    <div class="accountInfo">
                        <div class="infoPhoto">
                            <img v-if="valorantTrackerInfo.headImageUrl" :src="valorantTrackerInfo.headImageUrl" alt="" />
                            <div v-if="isCurrentUser" class="refreshInfo" :class="{ isFreshing: isFreshing }" @click="getInfo(true)">
                                <i></i>{{ isFreshing ? "正在更新" : "点击更新" }}
                            </div>
                        </div>
                        <div class="infoAccount">
                            <div class="infoTitle">
                                <span class="title">{{ valorantTrackerInfo.valorantUserNameCaption }}</span>
                                <span class="ltitle">{{ valorantTrackerInfo.valorantUserNameSuffix }}</span>
                                <span v-if="isCurrentUser" class="changeIcon" @click="changeAccount()">切换账号</span>
                            </div>
                            <div class="infoLevelMode">
                                <div class="level">Lv.{{ valorantTrackerInfo.level }}</div>
                                <div class="mode">
                                    <div @click="selectMode()">
                                        <p>{{ selectModes }}</p>
                                        <i></i>
                                    </div>
                                    <div @click="selectSeason()">
                                        <p>{{ selectSeasons }}</p>
                                        <i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="UpdateTime">
                        <i></i>
                        <div class="UpdateTimeText">
                            上次更新：{{ getTimeDiff(new Date(valorantTrackerInfo.updateTime).getTime(), new Date().getTime()) }}
                        </div>
                        <i></i>
                    </div>

                    <div class="levelGrid">
                        <div class="grid1">
                            <img v-if="valorantTrackerInfo.segmentImageUrl" :src="valorantTrackerInfo.segmentImageUrl" alt="" />
                            <div class="noImg" v-else></div>
                            <div>
                                <p class="rrNum" :class="{ noDataValue: valorantTrackerInfo.rr == '-' }">
                                    {{ valorantTrackerInfo.rr }}<span>RR</span>
                                </p>
                                <p>{{ valorantTrackerInfo.segmentsCn }}</p>
                            </div>
                        </div>
                        <div class="grid2">
                            <div class="victoriyOrLoseCount">
                                <span class="victoryCount" :class="{ noDataValue: valorantTrackerInfo.allWins == '-' }">{{
                                    valorantTrackerInfo.allWins
                                }}</span>
                                <span class="splitLine"></span>
                                <span class="loseCount" :class="{ noDataValue: valorantTrackerInfo.allLose == '-' }">{{
                                    valorantTrackerInfo.allLose
                                }}</span>
                            </div>
                            <div
                                class="victoriyOrLose"
                                :style="{
                                    background:
                                        'linear-gradient(to right, #1DB5AB ' +
                                        calcRate('win') +
                                        '%, #1DB5AB ' +
                                        calcRate('win') +
                                        '%, #D42D41 ' +
                                        calcRate('') +
                                        '%)',
                                }"
                            ></div>
                        </div>
                        <div class="grid3">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.damagePerRound == '-' }">
                                {{ valorantTrackerInfo.damagePerRound }}
                            </p>
                            <p class="inquryText">回合伤害</p>
                        </div>
                        <div class="grid4">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.kdRatio == '-' }">{{ valorantTrackerInfo.kdRatio }}</p>
                            <p class="inquryText">K/D</p>
                        </div>
                        <div class="grid5">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.headshotRate == '-' }">
                                {{ valorantTrackerInfo.headshotRate }}
                            </p>
                            <p class="inquryText">爆头率</p>
                        </div>
                        <div class="grid6">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.winRate == '-' }">{{ valorantTrackerInfo.winRate }}</p>
                            <p class="inquryText">胜率</p>
                        </div>
                    </div>
                    <div class="inquiryGrid" v-if="collapse">
                        <div class="grid2">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.killsPerRound == '-' }">
                                {{ valorantTrackerInfo.killsPerRound }}
                            </p>
                            <p class="inquryText">回合击杀数</p>
                        </div>
                        <div class="grid3">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.ddr == '-' }">{{ valorantTrackerInfo.ddr }}</p>
                            <p class="inquryText">DDR</p>
                        </div>
                        <div class="grid4">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.kast == '-' }">{{ valorantTrackerInfo.kast }}</p>
                            <p class="inquryText">KAST</p>
                        </div>
                        <div class="grid5">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.acs == '-' }">{{ valorantTrackerInfo.acs }}</p>
                            <p class="inquryText">每回合均分数</p>
                        </div>
                        <div class="grid6">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.kills == '-' }">{{ valorantTrackerInfo.kills }}</p>
                            <p class="inquryText">击杀数</p>
                        </div>
                        <div class="grid7">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.deaths == '-' }">{{ valorantTrackerInfo.deaths }}</p>
                            <p class="inquryText">死亡数</p>
                        </div>
                        <div class="grid8">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.assists == '-' }">{{ valorantTrackerInfo.assists }}</p>
                            <p class="inquryText">助攻数</p>
                        </div>
                        <div class="grid9">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.flawless == '-' }">
                                {{ valorantTrackerInfo.flawless }}
                            </p>
                            <p class="inquryText">无暇数</p>
                        </div>
                        <div class="grid10">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.aces == '-' }">{{ valorantTrackerInfo.aces }}</p>
                            <p class="inquryText">团灭数</p>
                        </div>
                        <div class="grid11">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.matches == '-' }">{{ valorantTrackerInfo.matches }}</p>
                            <p class="inquryText">总比赛场次</p>
                        </div>
                        <div class="grid10">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.playTime == '-' }">
                                {{ valorantTrackerInfo.playTime }}
                            </p>
                            <p class="inquryText">游戏时长</p>
                        </div>
                        <div></div>
                    </div>
                    <div class="closepall" @click="closepall()">{{ collapse ? "收起" : "展开" }}<i class="down" :class="{ up: !!collapse }"></i></div>
                    <div class="moduleInfo">
                        <div class="moduleItem" v-for="i in moduleList" @click="handleModuleClick(i)">
                            <img :src="i.iconUrl" alt="" />
                            <p>{{ i.title }}</p>
                        </div>
                    </div>
                    <div class="inquiryList">
                        <div class="listLabel">
                            <span>近期战绩</span>
                            <span class="allInquiry" @click="toList()">全部<i></i></span>
                        </div>
                        <div v-if="valorantTrackerInfo.matchInfoList && valorantTrackerInfo.matchInfoList.length">
                            <div class="listItem" v-for="infoItem in valorantTrackerInfo.matchInfoList" @click="ToDetail(infoItem)">
                                <div
                                    class="heroInfo"
                                    :class="{
                                        failed: parseInt(infoItem.enemyScore) > parseInt(infoItem.selfScore),
                                        tie: parseInt(infoItem.enemyScore) == parseInt(infoItem.selfScore),
                                    }"
                                >
                                    <img :src="infoItem.heroImageUrl" alt="" />
                                    <div class="hero">
                                        <p>{{ infoItem.heroNameCn }}</p>
                                        <p class="endTime">{{ infoItem.gameTime }}</p>
                                    </div>
                                </div>
                                <div class="scoreInfo">
                                    <p>
                                        <span :class="{ lose: parseInt(infoItem.enemyScore) < parseInt(infoItem.selfScore) }">{{
                                            infoItem.selfScore
                                        }}</span>
                                        ：{{ infoItem.enemyScore }}
                                    </p>
                                    <div
                                        :class="{
                                            mvp: infoItem.position == '1',
                                            second: parseInt(infoItem.position) == 2,
                                            third: parseInt(infoItem.position) == 3,
                                        }"
                                    >
                                        {{ positionText(infoItem.position) }}
                                    </div>
                                </div>
                                <div class="mapInfo">
                                    <p>{{ infoItem.mapCn }}</p>
                                    <div class="gameMode">{{ infoItem.modeCn }}</div>
                                </div>
                                <div class="resultInfo">
                                    <p>{{ infoItem.gameKda }}</p>
                                    <div>
                                        <span :class="{ lose: parseInt(infoItem.enemyScore) > parseInt(infoItem.selfScore) }">{{
                                            infoItem.gameKd
                                        }}</span>
                                        K/D
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="noData" v-else></div>
                    </div>
                </div>
            </div>
        </transition>
        <transition>
            <van-popup
                v-model="changeAccountModel"
                get-container="#app"
                round
                position="bottom"
                :safe-area-inset-bottom="true"
                :style="{ maxHeight: '455px', height: 'auto', borderRadius: '6px' }"
            >
                <div class="filterWeapon">
                    <div class="popupTitle">
                        <div class="titleText">切换账号</div>
                        <div class="addIcon" @click="addAccount()"><i></i>添加账号</div>
                    </div>
                    <div class="popupBody">
                        <div class="weaponsList">
                            <div class="weapons">
                                <div
                                    class="weaponMenu"
                                    v-for="plat in changeAccountList"
                                    :key="'稀有度' + plat.valorantUserName"
                                    @click="changeAccountOption(plat)"
                                >
                                    <div>
                                        {{ plat.valorantUserName }} <span>Lv.{{ plat.level }}</span>
                                    </div>
                                    <i v-if="valorantTrackerInfo && plat.valorantUserName == valorantTrackerInfo['valorantUserName']"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-popup>
        </transition>
    </div>
</template>

<script>
import inquiryApi from "../../assets/api/inquiryApi";
export default {
    name: "app",
    data() {
        return {
            isWeaponFilter: false,
            isSkinSort: false,
            account: "", // 输入的账号昵称,
            accountList: [],
            loading: true,
            loadError: false,
            needLogin: false,
            isFreshing: false, // 刷新数据
            VersionInterceptionDisplay: false, //版本拦截展示

            valorantTrackerInfo: null,
            collapse: false, //  是否展开
            moduleList: [
                {
                    title: "商店",
                    iconUrl: require("../../assets/image/icon_ShangDian.png"),
                    isBuilding: false,
                    contentUrl:
                        "https://app.gamersky.com/db/valorantSkin/index.html?gsGameId=1268241&gsAppChannel=diTu&gsAppChannelParams=toShangDian",
                },
                {
                    title: "皮肤库",
                    iconUrl: require("../../assets/image/icon_PiFuKu.png"),
                    isBuilding: false,
                    contentUrl:
                        "https://app.gamersky.com/db/valorantSkin/index.html?gsGameId=1268241&gsAppChannel=piFuKu&gsAppChannelParams=toPiFuKu",
                },
                {
                    title: "特工",
                    iconUrl: require("../../assets/image/icon_TeGong.png"),
                    isBuilding: true,
                    contentUrl: "",
                },
                {
                    title: "武器",
                    iconUrl: require("../../assets/image/icon_WuQi.png"),
                    isBuilding: true,
                    contentUrl: "",
                },
                {
                    title: "搜索",
                    iconUrl: require("../../assets/image/icon_SouSuo.png"),
                    isBuilding: true,
                    contentUrl: "",
                },
            ],
            gamerskyUserId: GSAppJsApi.User.getCurrentUserId(),
            isCurrentUser: true,

            modes: [],
            selectModes: "",

            seasons: [],
            selectSeasons: "",
            binding: false,
            didWindowGetFocus: false,
            loadedValorantTrackerInfo: false,
            isAndroid: false,
            isAppVersionGreaterThanOrEqual: false,
            changeAccountModel: false,
            changeAccountList: [],
            IsNeedLogin: false,
        };
    },
    watch: {
        needLogin(val) {
            setTimeout(() => {
                if (val && this.IsNeedLogin) {
                    GSAppJsApi.EventStatistics.recordEvent("Z100108", "", 0);
                    this.record(108, this.gamerskyUserId);
                }
            }, 1);
        },
        IsNeedLogin(val) {
            setTimeout(() => {
                if (val && this.needLogin) {
                    GSAppJsApi.EventStatistics.recordEvent("Z100108", "", 0);
                    this.record(108, this.gamerskyUserId);
                }
            }, 1);
        },
    },
    mounted() {
        let that = this;
        const gsAppChannelParams = this.$utils.getQueryString("gsAppChannelParams");

        if (gsAppChannelParams && gsAppChannelParams != "addValorantAccount") {
            if (gsAppChannelParams != "toShangDian" && gsAppChannelParams != "toPiFuKu") {
                this.gamerskyUserId = this.$utils.getQueryString("gsAppChannelParams");
                this.isCurrentUser = false;
            }
        }
        this.DetermineVersion(); // 判断是否是 6.22.30 或以上版本
        this.$utils.reredirectPage();
        if (gsAppChannelParams == "addValorantAccount") {
            this.needLogin = true;
            this.loading = false;
            this.getBindAccountList();
            this.isCurrentUser = true;

            // return
        } else {
            this.getBindInfo();
            // 20251204无畏契约战绩恢复1.0 注释，后端找不到接口代码
            // this.getQuickInputList();
            if (this.isCurrentUser) {
                this.getBindAccountList();
            }
        }

        GSAppJsApi.UI.setBrowserUI("Dark", true, true);
        window.addEventListener("scroll", this.scroll);
        this.isAppVersionGreaterThanOrEqual = GSAppJsApi.Environment.isAppVersionGreaterThanOrEqual("6.22.52");
        this.isAndroid = GSAppJsApi.Environment.isInAppWebViewInAndroid();
        // 安卓端， 或 版本号大于等于 6.22.52 上报总 和 已绑定访问统计
        if (this.isAppVersionGreaterThanOrEqual || this.isAndroid) {
            GSAppJsApi.UI.didWindowGetFocus = function() {
                that.didWindowGetFocus = true;

                setTimeout(function() {
                    if (that.loadedValorantTrackerInfo) {
                        GSAppJsApi.EventStatistics.recordEvent("Z100011", "", 0);
                        GSAppJsApi.EventStatistics.recordEvent("Z100089", "无畏契约", 0);
                        GSAppJsApi.EventStatistics.recordEvent("A13319_全局_游戏工具", "无畏契约战绩查询", 0);
                        GSAppJsApi.UMeng.recordEvent("A13319_全局_游戏工具", "无畏契约战绩查询");
                    }
                    that.IsNeedLogin = true;
                }, 1);
                GSAppJsApi.EventStatistics.recordEvent("Z100010", "", 0);
            };
        }
        GSAppJsApi.UI.sharePage = function() {
            // !!!
            const shareInfo = GSAppJsApi.UI.createShareInfo(
                "renYi",
                "https://image.gamersky.com/zqimg/valorant/image/cover.jpg",
                "无畏契约战绩查询",
                "点击绑定并查询您的战绩信息",
                "https://app.gamersky.com/zt/valorant/valorantWap.html",
                "",
                0,
                () => {}
            );
            GSAppJsApi.UI.share(shareInfo);
            GSAppJsApi.EventStatistics.recordEvent("Z100029", "", 0);

            // !!!
            return "yiFenXiang";
        };
        GSAppJsApi.UI.registerNotificationListener("gamersky.app.shareButtonClicked", function(response) {
            if (response.title == "无畏契约战绩查询") {
                GSAppJsApi.EventStatistics.recordEvent("Z100029", "首页", 0);
                GSAppJsApi.EventStatistics.recordEvent("Z200448", "", 0);
            }
        });
    },
    methods: {
        changeAccountOption(account) {
            const params = {
                gamerskyUserId: this.gamerskyUserId,
                valorantUserName: account.valorantUserName,
            };

            inquiryApi
                .changeActiveAccount(params)
                .then((res) => {
                    if (!res.error) {
                        this.getBindInfo();
                    }
                    this.changeAccountModel = false;
                })
                .catch((err) => {});
        },
        record(type, gsUserId) {
            var params = {
                siteName: "01",
                type: type,
                gsUserId: gsUserId,
                errorInfo: "",
            };
            inquiryApi.reportStatus(params);
        },
        getBindAccountList() {
            if (!this.gamerskyUserId) {
                this.needLogin = true;
                this.loading = false;
                return false;
            }
            const bindInfo = {
                gamerskyUserId: this.gamerskyUserId,
            };
            inquiryApi
                .getBindAccountList(bindInfo)
                .then((res) => {
                    if (!res.error && res.bindAccountList) {
                        this.changeAccountList = res.bindAccountList;
                    }

                    console.log(this.changeAccountList);
                })
                .catch((err) => {});
        },
        toList() {
            // var a = document.createElement("a");
            // a.href = `./recordList.html?&appNavigationBarStyle=kNoneBar`;
            // a.target = "_blank";
            // a.click()

            let url = this.$utils.getCurrentUrl() + "recordList.html";
            let params = {};
            if (!this.isCurrentUser) {
                params = {
                    gsAppChannelParams: this.gamerskyUserId,
                };
            }
            this.$utils.openWithNewWindow(url, params);
        },
        ToDetail(e) {
            var that = this;
            if (e.mode == "deathmatch") {
                that.$toast({
                    type: "error",
                    message: "该比赛类型暂时无法查看详情",
                    time: 2000,
                });
                return;
            }
            this.$utils.openWithNewWindow(this.$utils.getCurrentUrl() + "recordDetails.html", {
                matchId: encodeURIComponent(e.trackerId),
                mode: encodeURIComponent(e.mode),
                season: encodeURIComponent(e.season),
                userName: encodeURIComponent(e.valorantUserName),
            });
        },
        getTimeDiff(timestamp1, timestamp2) {
            // 将时间戳转换为毫秒数
            var diffInMilliseconds = Math.abs(timestamp2 - timestamp1);

            // 计算时间差的分钟数
            var diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

            // 根据分钟数返回相应的时间间隔文本
            if (diffInMinutes <= 0) {
                return "1分钟以内";
            } else if (diffInMinutes < 60) {
                return diffInMinutes + "分钟前";
            } else if (diffInMinutes < 1440) {
                return Math.floor(diffInMinutes / 60) + "小时前";
            } else {
                return Math.floor(diffInMinutes / 1440) + "天前";
            }
        },

        positionText(position) {
            if (position == 1) {
                return "MVP";
            }
            if (position == 2) {
                return "2nd";
            }
            if (position == 3) {
                return "3rd";
            }
            return position + "th";
        },
        calcRate(tye) {
            const a = parseInt(this.valorantTrackerInfo.allWins);
            const b = parseInt(this.valorantTrackerInfo.allLose);
            if (tye == "win") {
                console.log * (a / (a + b));
                return (a / (a + b)) * 100;
            } else {
                console.log(b / (a + b));
                return (b / (a + b)) * 100;
            }
        },

        closepall() {
            this.collapse = !this.collapse;
        },

        handleModuleClick(item) {
            GSAppJsApi.EventStatistics.recordEvent("Z100016", item.title || "", 0);
            if (item.isBuilding) {
                this.$toast({
                    type: "error",
                    message: "该功能加紧建设中，即将上线!",
                    time: 2000,
                });
                setTimeout(() => {
                    // this.$toast.close()
                }, 1000);
                return;
            }
            this.$utils.openWithNewWindow(item.contentUrl);
        },

        // 选择模式
        selectMode() {
            let buttonGroupNames = ["比赛模式"];
            let modes = this.modes;
            let buttonInfes = [];
            for (let i = 0; i < modes.length; i++) {
                buttonInfes.push({
                    groupName: modes[i].label,
                    iconUrl: "",
                    name: modes[i].label,
                    beSelected: this.selectModes == modes[i].label ? true : false,
                });
            }
            let that = this;
            GSAppJsApi.UI.openMenu("anNiu_danXuan", buttonGroupNames, buttonInfes, function(e) {
                that.selectModes = e.selectedButtonNames[0];
                that.getUserData();
            });
        },

        // 选择赛季
        selectSeason() {
            let buttonGroupNames = ["赛季"];
            let seasons = this.seasons;
            let buttonInfes = [];
            for (let i = 0; i < seasons.length; i++) {
                buttonInfes.push({
                    groupName: seasons[i].label,
                    iconUrl: "",
                    name: seasons[i].label,
                    beSelected: this.selectSeasons == seasons[i].label ? true : false,
                });
            }
            let that = this;
            GSAppJsApi.UI.openMenu("anNiu_danXuan", buttonGroupNames, buttonInfes, function(e) {
                console.log("e", e);
                that.selectSeasons = e.selectedButtonNames[0];
                that.getUserData();
            });
        },

        // 账号是否已绑定
        isAccountBinded() {
            if (this.changeAccountList && this.changeAccountList.length > 0) {
                console.log("changeAccountList", this.changeAccountList);
                let account = this.changeAccountList.filter((account) => account && account.valorantUserName == this.account);
                if (account && account.length > 0) {
                    this.$toast({
                        type: "error",
                        message: "该账号已绑定请重新输入",
                    });
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },

        // 绑定账号
        bind() {
            // if (this.$utils.versionStringCompare(GSAppJsApi.Environment.getAppVersion(), '6.22.10') < 0) {
            //     var a = document.createElement("A");
            //     {
            //         a.target = "_blank";
            //         a.href = "https://app.gamersky.com/oth/versionupgrade/";
            //     }
            //     a.click();
            //     return false
            // } else {
            this.loading = true;
            // - 无畏契约-战绩-立即绑定     - 立即绑定按钮点击时
            GSAppJsApi.EventStatistics.recordEvent("Z100012", "", 0);
            if (!this.account) {
                this.$toast({
                    type: "error",
                    message: "请输入游戏昵称",
                });
                this.needLogin = true;
                this.loading = false;
                return;
            }
            //   输入账号，并点击按钮   - 无畏契约_统计模型_有效点击绑定按钮
            GSAppJsApi.EventStatistics.recordEvent("Z100109", "", 0);
            this.record(109, this.gamerskyUserId);
            // 绑定操作
            GSAppJsApi.User.loginTo((isComplated) => {
                if (isComplated && this.isAccountBinded()) {
                    this.gamerskyUserId = GSAppJsApi.User.getCurrentUserId();
                    this.loading = true;

                    const params = {
                        valorantUserName: this.account,
                        gamerskyUserId: this.gamerskyUserId,
                    };
                    inquiryApi
                        .bindAccount(params)
                        .then((res) => {
                            if (!res.error || res.error == null) {
                                this.binding = true;
                                this.getBindInfo();
                                this.getBindAccountList();
                                this.needLogin = false;
                                this.loading = false;
                            } else {
                                if (res.error == "451") {
                                    // - 无畏契约-战绩-绑定失败-触发登录     - 新绑定账号，请求数据时，触发了拳头账号登录导致失败时报送
                                    GSAppJsApi.EventStatistics.recordEvent("Z100020", "", 0);
                                    this.$toast({
                                        type: "error",
                                        message: "绑定失败",
                                    });
                                } else if (res.error == "404") {
                                    // - 无畏契约-战绩-绑定失败-账号不存在
                                    GSAppJsApi.EventStatistics.recordEvent("Z200449", "", 0);
                                    this.$toast({
                                        type: "error",
                                        message: "绑定失败",
                                    });
                                } else {
                                    this.$toast({
                                        type: "error",
                                        message: res.error,
                                    });
                                }

                                this.loading = false;
                                this.needLogin = true;

                                // - 无畏契约-战绩-绑定失败     - 新绑定账号，请求数据时，无论因什么原因，导致没正常展示数据时报送
                                GSAppJsApi.EventStatistics.recordEvent("Z100019", "", 0);
                            }
                        })
                        .catch((err) => {
                            this.$toast({
                                type: "error",
                                message: "绑定失败",
                            });
                            // - 无畏契约-战绩-绑定失败     - 新绑定账号，请求数据时，无论因什么原因，导致没正常展示数据时报送
                            GSAppJsApi.EventStatistics.recordEvent("Z100019", "", 0);
                            this.loading = false;
                            this.needLogin = true;
                        });
                }
            });

            // }
        },

        // 解除绑定
        unBind() {
            inquiryApi
                .unBindAccount({
                    gamerskyUserId: this.gamerskyUserId,
                })
                .then((res) => {
                    this.$toast({
                        type: "success",
                        message: "解绑成功",
                    });
                    location.reload();
                })
                .catch((err) => {});
        },

        // 获取用户绑定账号信息
        getBindInfo() {
            if (!this.gamerskyUserId) {
                this.needLogin = true;
                return false;
            }
            const bindInfo = {
                gamerskyUserId: this.gamerskyUserId,

                // gamerskyUserId: 8059792,
            };
            inquiryApi
                .getBindInfo(bindInfo)
                .then((res) => {
                    // 有绑定账号
                    if (!res.error && res.valorantUserName) {
                        this.account = res.valorantUserName;
                        this.needLogin = false;
                        this.getUserData();
                    } else {
                        this.needLogin = true;
                        this.loading = false;
                    }
                    console.log(res);
                })
                .catch((err) => {});
        },

        // 获取用户战绩信息
        getUserData(isFresh) {
            var that = this;
            this.loadError = false;

            const params = {
                gamerskyUserId: this.gamerskyUserId,
                mode: this.selectModes,
                season: this.selectSeasons,
                isUpdate: isFresh,
            };

            inquiryApi
                .getTrackeInfo(params)
                .then((res) => {
                    // alert(JSON.stringify(res.code))
                    // 无畏契约战绩_绑定成功
                    if (this.binding && !isFresh) {
                        GSAppJsApi.EventStatistics.recordEvent("Z100013", "", 0);
                    }

                    this.valorantTrackerInfo = res.valorantTrackerInfo;
                    this.modes = res.modes;
                    this.selectModes = res.valorantTrackerInfo.defaultMode;
                    this.seasons = res.seasons;
                    this.selectSeasons = res.valorantTrackerInfo.passon;
                    if (isFresh) {
                        GSAppJsApi.EventStatistics.recordEvent("Z200447", "", 0);
                        this.isFreshing = false;
                        if (res.error == "451") {
                            // - 无畏契约-战绩-绑定失败-触发登录     - 新绑定账号，请求数据时，触发了拳头账号登录导致失败时报送
                            GSAppJsApi.EventStatistics.recordEvent("Z100020", "", 0);
                            GSAppJsApi.EventStatistics.recordEvent("Z100019", "", 0);

                            this.$toast({
                                type: "error",
                                message: "绑定失败",
                            });
                        } else if (res.error == "404") {
                            // - 无畏契约-战绩-绑定失败-账号不存在
                            GSAppJsApi.EventStatistics.recordEvent("Z200449", "", 0);
                            GSAppJsApi.EventStatistics.recordEvent("Z100019", "", 0);

                            this.$toast({
                                type: "error",
                                message: "绑定失败",
                            });
                        }
                    }
                    if (!this.loadedValorantTrackerInfo) {
                        GSAppJsApi.EventStatistics.recordEvent("Z100011", "", 0);
                    }
                    this.loadedValorantTrackerInfo = true;
                    this.binding = false;
                    this.loading = false;

                    // if (res.code != 0) {
                    //     var isReFresh = isFresh ? true : false
                    //     var mode = this.modes.length > 0 ? this.modes.find(element => element.label === this.selectModes)?.value : '';
                    //     var season = this.seasons.length > 0 ? this.seasons.find(element => element.label === this.selectSeasons)?.value : '';

                    //     // 调用爬虫
                    //     var CurrentAddress = 'https://tracker.gg/valorant/profile/riot/' + encodeURIComponent(this.account) + '/overview?UserName=' + encodeURIComponent(this.account) + '&mode=' + encodeURIComponent(mode) + '&season=' + encodeURIComponent(season) + '&isReFresh=' + encodeURIComponent(isReFresh);
                    //     var CrawlerAddress = 'https://app.gamersky.com/tools/appGotJsTo/valorant_stats_crawler/getData.js';
                    //     // var CrawlerAddress = 'https://project-test.gamersky.com/app/valorant/getData.js';

                    //     // alert(CurrentAddress)
                    //     if (mode || season) {
                    //         CrawlerAddress = 'https://app.gamersky.com/tools/appGotJsTo/valorant_stats_crawler/getSeasonAndModeData.js';
                    //         // CrawlerAddress = 'https://project-test.gamersky.com/app/valorant/getSeasonAndModeData.js';
                    //     }

                    //     // 开启监听  是否弹出登录窗口
                    //     GSAppJsApi.UI.registerNotificationListener("gamersky.app.crawler.state.riotLogin", (response) => {
                    //         if (response == 'dengLuQuanTou') {
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100017', '', 0);
                    //         }
                    //     });

                    //     // 开启监听  开始抓取数据
                    //     GSAppJsApi.UI.registerNotificationListener("gamersky.app.crawler.state.getData", (response) => {
                    //         if (response == 'kaiShiZhuaQu') {
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100018', '', 0);
                    //         }
                    //     });

                    //     that.$utils.CallCrawler(CurrentAddress, CrawlerAddress, (res) => {
                    //         if (res == 'chengGong') {
                    //             that.getUserData()
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100015', '', 0);
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100019', '', 0);
                    //             that.$toast({
                    //                 type: "success",
                    //                 message: "加载成功",
                    //                 time: 2000,
                    //             });
                    //         } else {
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100020', '', 0);
                    //             that.$toast({
                    //                 type: "error",
                    //                 message: "加载失败",
                    //                 time: 2000,
                    //             });
                    //         }
                    //     })
                    // } else {
                    //     clearTimeout(ShowLoding);

                    //     if (res.error) {
                    //         this.getInfo();
                    //     } else {
                    //         // 无畏契约战绩_绑定成功
                    //         if (this.binding && !isFresh) {
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100013', '', 0);
                    //             this.binding = false;
                    //         }

                    //         this.valorantTrackerInfo = res.valorantTrackerInfo;

                    //         this.modes = res.modes
                    //         this.selectModes = res.valorantTrackerInfo.defaultMode

                    //         this.seasons = res.seasons
                    //         this.selectSeasons = res.valorantTrackerInfo.passon

                    //         this.loading = false;
                    //         // 安卓端， 或 版本号大于等于 6.22.52 上报总 和 已绑定访问统计
                    //         if (this.isAppVersionGreaterThanOrEqual || this.isAndroid) {
                    //             if (this.isCurrentUser && !isFresh && this.didWindowGetFocus) {
                    //                 GSAppJsApi.EventStatistics.recordEvent('Z100011', '', 0);
                    //                 GSAppJsApi.EventStatistics.recordEvent("Z100089", "无畏契约", 0);
                    //                 GSAppJsApi.EventStatistics.recordEvent("A13319_全局_游戏工具", "无畏契约战绩查询", 0);
                    //                 GSAppJsApi.UMeng.recordEvent('A13319_全局_游戏工具', '无畏契约战绩查询');
                    //             }
                    //         }
                    //         this.loadedValorantTrackerInfo = true;

                    //         this.$toast({
                    //             type: "success",
                    //             message: "加载成功",
                    //             time: 2000,
                    //         });

                    //         if (isFresh) {
                    //             this.isFreshing = false
                    //         }
                    //     }
                    // }
                    // this.getBindAccountList();
                })
                .catch((err) => {
                    this.valorantTrackerInfo = null;
                    this.loading = false;
                    this.loadError = true;
                });
        },

        DetermineVersion() {
            if (this.$utils.versionStringCompare(GSAppJsApi.Environment.getAppVersion(), "6.22.30") < 0) {
                this.VersionInterceptionDisplay = true;
                this.Upgrade();
            }
        },
        Upgrade() {
            var a = document.createElement("A");
            {
                a.target = "_blank";
                a.href = "https://app.gamersky.com/oth/versionupgrade/";
            }
            a.click();
        },
        getInfo(isReFresh) {
            var that = this;
            if (!isReFresh) {
                setTimeout(() => {
                    this.loading = true;
                    this.loadError = false;
                }, 800);
            }
            this.loadError = false;
            this.isFreshing = true;
            var isReFreshText = false;
            if (isReFresh) {
                isReFreshText = true;
                GSAppJsApi.EventStatistics.recordEvent("Z100014", "刷新账号", 0);
                GSAppJsApi.EventStatistics.recordEvent("Z200446", "", 0);
            } else {
                GSAppJsApi.EventStatistics.recordEvent("Z100014", "", 0);
            }
            this.getUserData(isReFresh);

            // if (this.$utils.versionStringCompare(GSAppJsApi.Environment.getAppVersion(), '6.22.10') < 0) {
            //     // 老版本
            //     GSAppJsApi.invokeUrlCommand('https://app.gamersky.com/oth/versionupgrade/?gsAppPageName=valorantCrawer&valorantUserName=' + encodeURIComponent(this.account));
            //     // this.$utils.openWithNewWindow('https://app.gamersky.com/oth/versionupgrade/?gsAppPageName=valorantCrawer&valorantUserName=' + this.account);
            //     GSAppJsApi.UI.registerNotificationListener("gamersky.app.valorant.userdatacraw", (response) => {
            //         this.loading = false;
            //         this.needLogin = false;
            //         if (response.crawResult == 'chengGong') {
            //             GSAppJsApi.EventStatistics.recordEvent('Z100015', '', 0);

            //         } else if (response.crawResult == 'shiBai') {
            //             // 失败
            //             this.loadError = true;
            //             this.isFreshing = false;

            //         } else if (response.crawResult == 'yongHuBuCunZai') {
            //             // 用户不存在
            //             this.loadError = false;
            //             this.isFreshing = false;
            //             this.$toast({
            //                 type: "error",
            //                 message: '账号不存在，请检查并重试',
            //             });
            //             this.needLogin = true;
            //             this.unBind();

            //         }else{
            //             // 用户不存在
            //             this.loadError = false;
            //             this.isFreshing = false;
            //             this.$toast({
            //                 type: "error",
            //                 message: '数据源波动中<br>请稍后再试',
            //             });
            //             this.needLogin = true;
            //             this.unBind();

            //         }
            //         this.isFreshing = false;

            //     });
            // } else {
            //     var CurrentAddress = 'https://tracker.gg/valorant/profile/riot/' + encodeURIComponent(this.account) + '/overview?UserName=' + encodeURIComponent(this.account) + '&isReFresh=' + encodeURIComponent(isReFreshText);
            //     // var CrawlerAddress = 'https://app.gamersky.com/tools/appGotJsTo/valorant_stats_crawler/getData.js';
            //     var CrawlerAddress = 'https://project-test.gamersky.com/app/valorant/getData.js';
            //     alert(CurrentAddress)

            //     // 开启监听  是否弹出登录窗口
            //     GSAppJsApi.UI.registerNotificationListener("gamersky.app.crawler.state.riotLogin", (response) => {
            //         if (response == 'dengLuQuanTou') {
            //             GSAppJsApi.EventStatistics.recordEvent('Z100017', '', 0);
            //         }
            //     });

            //     // 开启监听  开始抓取数据
            //     GSAppJsApi.UI.registerNotificationListener("gamersky.app.crawler.state.getData", (response) => {
            //         if (response == 'kaiShiZhuaQu') {
            //             GSAppJsApi.EventStatistics.recordEvent('Z100018', '', 0);
            //         }
            //     });
            //     that.$utils.CallCrawler(CurrentAddress, CrawlerAddress, (res) => {
            //         if (res == 'chengGong') {
            //             if (isReFresh) {
            //                 GSAppJsApi.EventStatistics.recordEvent('Z100015', '刷新账号', 0);
            //                 // 点击更新更新成功
            //                 GSAppJsApi.EventStatistics.recordEvent('Z100019', '', 0);
            //             } else {
            //                 GSAppJsApi.EventStatistics.recordEvent('Z100015', '', 0);
            //                 // 无畏契约_统计模型_绑定成功
            //                 GSAppJsApi.EventStatistics.recordEvent('Z100117', '', 0);
            //                 this.record(117, this.gamerskyUserId);
            //             }
            //             var message = isReFresh ? '更新成功' : '绑定成功'
            //             that.isFreshing = false;
            //             that.$toast({
            //                 type: 'success',
            //                 message: message
            //             })
            //             that.getUserData()
            //         } else if (res == 'yongHuBuCunZai') {
            //             // 用户不存在
            //             this.loadError = false;
            //             this.isFreshing = false;
            //             this.loading = false;
            //             this.$toast({
            //                 type: "error",
            //                 message: '账号不存在，请检查并重试',
            //             });
            //             this.needLogin = true;
            //             this.unBind();

            //         }else if(res == 'renJiYanZheng' || res == 'faShengCuoWu'){
            //             // 用户不存在
            //             this.loadError = false;
            //             this.isFreshing = false;
            //             this.loading = false;
            //             this.$toast({
            //                 type: "error",
            //                 message: '数据源波动中<br>请稍后再试',
            //             });
            //             this.needLogin = true;
            //             this.unBind();
            //         } else {
            //             that.isFreshing = false;
            //             GSAppJsApi.EventStatistics.recordEvent('Z100020', '', 0);
            //             that.loading = false;
            //             that.$toast({
            //                 type: 'error',
            //                 message: '更新失败'
            //             })
            //         }
            //     })
            // }
        },

        getQuickInputList() {
            const params = {
                gamerskyUserId: this.gamerskyUserId,
                // gamerskyUserId: 8059792
            };
            inquiryApi.getQuickAccounts(params).then((res) => {
                console.log("res", res);
                if (!res.error) {
                    this.accountList = res.data;
                }
            });
        },
        changeAccount() {
            this.changeAccountModel = true;
            // this.valorantTrackerInfo = {};
        },
        addAccount() {
            this.record(108, this.gamerskyUserId);
            this.changeAccountModel = false;
            this.needLogin = true;
            this.loading = false;
            this.account = "";
            this.selectModes = "";
            this.selectSeasons = "";
        },
    },
};
</script>

<style lang="scss" scoped>
#app {
    margin: 0 auto;
    // max-width: 700px;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    overflow-y: hidden;
    position: relative;
    background: #0d151e;
    font-family: PingFang SC, PingFang SC-Bold;

    &.notScroll {
        overflow: hidden;
    }

    .MaskUpgradeVersionTemplate {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        max-width: 700px;
        width: 100%;
        height: 100vh;
    }

    .contentArea {
        margin: 0 auto;
        position: relative;
        max-width: 700px;
        height: 100vh;
        background: url("../../assets/image/img_bg.png") no-repeat top / 100% auto;
        .loading {
            position: absolute;
            top: 40%;
            left: 50%;
            width: 30px;
            height: 30px;
            background: url("../../assets/image/loading.png") no-repeat top / 100%;
            transform: translate(-50%, -50%);
            animation: rotate 1s linear infinite;
        }
    }

    .container {
        width: 100%;
        padding: 50vh 52px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;

        .topTips {
            width: 100%;
            position: absolute;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: Regular;
            text-align: center;
            color: rgba(255, 255, 255, 0.5);
            height: 32px;
            background: rgba(235, 65, 61, 0.1);
        }

        input {
            padding-left: 10px;
            height: 44px;
            width: 100%;
            background: #192129;
            border: 0.5px solid #26313c;
            border-radius: 4px;
            color: #d7d7d9;
            box-sizing: border-box;

            &::placeholder {
                color: #3f424a;
            }
        }

        .quickInput {
            margin-top: 16px;
            width: 100%;

            .label {
                width: 84px;
                height: 17px;
                font-size: 12px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                text-align: left;
                color: #48484b;
                line-height: 16px;
            }

            .accountList {
                span {
                    display: inline-block;
                    margin: 8px 8px 0 0;
                    padding: 5px 8px;
                    font-size: 12px;
                    background: rgba(25, 33, 41, 0);
                    border: 0.5px solid #1c2229;
                    border-radius: 4px;
                    color: #717173;
                }
            }
        }

        .bindBtn {
            margin-top: 16px;
            width: 100%;
            height: 40px;
            background: #eb413d;
            border-radius: 3px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: bold;
            text-align: center;
            color: #ffffff;
            line-height: 40px;
        }

        .tips {
            margin-top: 20px;
            opacity: 0.3;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: center;
            color: #ffffff;
        }
    }

    .mainArea {
        margin: 0 auto;
        position: relative;
        max-width: 700px;
        height: 100vh;
        background: url("../../assets/image/img_TopBg.png") no-repeat top / 100% auto;
        overflow: auto;

        .loading {
            position: relative;
            top: 200px;
            left: 50%;
            width: 46px;
            height: 46px;
            background: url("../../assets/image/loading.png") no-repeat top / 100%;
            transform: translate(-50%, -50%);
            animation: rotate 1s linear infinite;
        }

        .loadingTxt {
            color: rgb(255, 255, 255);
            position: relative;
            top: 180px;
            /* width: 80%; */
            text-align: center;
            margin: 0 20px;
            color: #55555d;
            font-size: 12px;
            line-height: 20px;

            span {
                display: block;
                margin-top: 8px;
                margin-bottom: 18px;
                font-size: 14px;
                color: #a3a3a6;
                line-height: 20px;
            }
        }

        .loadError {
            position: relative;
            top: 277px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: center;
            color: #ffffff;

            .dataErrorTips {
                opacity: 0.3;
            }

            .reloadDataBtn {
                margin: 20px auto;
                width: 172px;
                height: 42px;
                background: #eb413d;
                border-radius: 3px;
                font-size: 16px;
                font-family: PingFang SC, PingFang SC-Medium;
                font-weight: 500;
                text-align: center;
                color: #ffffff;
                line-height: 42px;
            }
        }
    }

    .inquiryInfo {
        padding: 20px 16px 30px;
        width: 100%;
        height: auto;
        box-sizing: border-box;

        .accountInfo {
            display: flex;

            .infoPhoto {
                position: relative;
                width: 80px;
                height: 80px;
                overflow: hidden;

                img {
                    width: 80px;
                    height: 80px;
                }

                .refreshInfo {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 80px;
                    height: 18px;
                    background: rgba(0, 0, 0, 0.6);
                    font-size: 10px;
                    color: rgba(255, 255, 255, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    i {
                        margin-right: 2px;
                        width: 14px;
                        height: 14px;
                        display: inline-block;
                        background: url("../../assets/image/icon_ShuaXin.png") no-repeat center / 14px;
                    }

                    &.isFreshing {
                        i {
                            background: url("../../assets/image/icon_LoadingHuaBan.gif") no-repeat center / 14px;
                        }
                    }
                }
            }

            .infoAccount {
                display: flex;
                flex-direction: column;
                margin-left: 12px;
                flex-grow: 1;
                // justify-content: center;

                .infoTitle {
                    display: flex;
                    align-items: center;
                    color: rgba(255, 255, 255, 0.5);
                    margin-top: 7px;
                }

                .title {
                    max-width: 116px;
                    margin-right: 4px;
                    height: 28px;
                    opacity: 0.9;
                    font-size: 20px;
                    font-family: PingFang SC, PingFang SC-Bold;
                    font-weight: 700;
                    text-align: left;
                    color: #ffffff;
                    line-height: 24px;
                    white-space: nowrap;
                    /* 强制不换行 */
                    overflow: hidden;
                    /* 隐藏溢出部分 */
                    text-overflow: ellipsis;
                }

                .ltitle {
                    max-width: 64px;
                    white-space: nowrap;
                    font-size: 14px;
                    /* 强制不换行 */
                    overflow: hidden;
                    /* 隐藏溢出部分 */
                    text-overflow: ellipsis;
                }

                .changeIcon {
                    margin-left: 8px;
                    width: 56px;
                    height: 18px;
                    border-radius: 3px;
                    background: rgba(255, 255, 255, 0.1) url("../../assets/image/icon_PaiXu_8x8@2x.png") no-repeat 4px center / 8px 8px;
                    font-size: 9px;
                    text-indent: 16px;
                    display: flex;
                    align-items: center;
                }
            }

            .infoLevelMode {
                margin-top: 10px;
                display: flex;
                justify-content: space-between;

                .level {
                    padding: 2px 5px;
                    font-size: 12px;
                    height: 22px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.9);
                    background: rgba(255, 255, 255, 0.1);
                    box-sizing: border-box;
                }

                .mode {
                    font-size: 12px;
                    // padding: 2px 5px;
                    display: flex;
                    color: rgba(255, 255, 255, 0.9);

                    div {
                        box-sizing: border-box;
                        padding: 0 5px;
                        height: 22px;
                        line-height: 22px;
                        background: rgba(255, 255, 255, 0.1);
                        margin-left: 8px;
                        display: flex;
                        align-items: center;

                        p {
                            max-width: 70px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }

                        i {
                            margin-left: 4px;
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            background: url("../../assets/image/icon_ LinearArrowDown_White.png") no-repeat center / 8px;
                        }
                    }
                }
            }
        }

        .UpdateTime {
            // width: 74px;
            height: 21px;
            font-size: 9px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: Regular;
            text-align: center;
            color: rgba(255, 255, 255, 0.3);
            line-height: 21px;
            margin: 6px auto 4px;
            display: flex;
            align-items: center;

            .UpdateTimeText {
                padding: 0 14px;
            }

            i {
                width: auto;
                flex: 1;
                height: 1px;
                display: block;
                background: rgba(255, 255, 255, 0.05);
            }
        }

        .levelGrid {
            // margin-top: 20px;
            margin-bottom: 8px;
            display: grid;
            grid-template-columns: repeat(4, 2fr);
            grid-template-rows: 1fr;
            gap: 5px;

            div {
                height: 56px;
                background: rgba(255, 255, 255, 0.05);
            }

            .grid1 {
                grid-column: span 2;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    margin-right: 20px;
                    width: 36px;
                    height: 36px;
                }

                .noImg {
                    margin-right: 20px;

                    width: 36px;
                    height: 36px;
                    background: rgba(255, 255, 255, 0.1);
                }

                div {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    font-size: 10px;
                    background: transparent;
                    color: rgba(255, 255, 255, 0.5);

                    .rrNum {
                        font-size: 16px;
                        line-height: 22px;
                        color: rgba(255, 255, 255, 0.9);
                        font-weight: bold;

                        span {
                            position: relative;
                            top: -6px;
                            left: 3px;
                            font-size: 8px;
                        }
                    }
                }
            }

            .grid2 {
                grid-column: span 2;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .victoriyOrLose {
                    width: calc(100% - 72px);
                    height: 2px;
                    margin: 8px 36px 0;
                    background-color: #0ab99f;
                    box-sizing: border-box;
                }

                .victoriyOrLoseCount {
                    height: 22px;
                    background: transparent;
                    display: flex;
                    align-items: center;

                    .victoryCount,
                    .loseCount {
                        font-size: 16px;
                        line-height: 22px;
                        color: rgba(255, 255, 255, 0.9);
                    }

                    .victoryCount {
                        &::after {
                            position: relative;
                            left: 3px;
                            content: "W";
                            color: #0ab99f;
                            font-size: 8px;
                        }
                    }

                    .loseCount {
                        &::after {
                            position: relative;
                            left: 3px;
                            content: "L";
                            color: #d42d41;
                            font-size: 8px;
                        }
                    }

                    .splitLine {
                        display: inline-block;
                        margin: 0 11px 0 13px;
                        width: 6px;
                        height: 1px;
                        background: rgba(255, 255, 255, 0.2);
                    }
                }
            }

            .grid3,
            .grid4,
            .grid5,
            .grid6 {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .inquryText {
                font-size: 10px;
                font-weight: normal;
                text-align: center;
                color: rgba(255, 255, 255, 0.5);
            }

            .inquryValue {
                font-size: 16px;
                font-weight: normal;
                text-align: center;
                color: rgba(255, 255, 255, 0.8);
            }
        }

        .inquiryGrid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-template-rows: repeat(3, 52px);

            div {
                position: relative;
                height: 52px;
                background: rgba(255, 255, 255, 0.05);
                display: flex;
                flex-direction: column;
                justify-content: center;

                .inquryText {
                    font-size: 10px;
                    font-weight: normal;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.5);
                }

                .inquryValue {
                    font-size: 14px;
                    font-weight: normal;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.8);
                }

                &::after {
                    position: absolute;
                    right: 0;
                    top: 50%;
                    margin-top: -10px;
                    content: "";
                    width: 1px;
                    height: 20px;
                    background: rgba(255, 255, 255, 0.1);
                }

                &:nth-child(4) {
                    &::after {
                        width: 0;
                    }
                }

                &:nth-child(8) {
                    &::after {
                        width: 0;
                    }
                }

                &:nth-child(12) {
                    &::after {
                        width: 0;
                    }
                }
            }
        }

        .closepall {
            width: 100%;
            height: 30px;
            background: rgba(255, 255, 255, 0.05);
            color: #999;
            font-size: 10px;
            text-align: center;
            line-height: 30px;

            // 展开
            .down {
                margin-left: 4px;
                display: inline-block;
                width: 8px;
                height: 8px;
                background: url("../../assets/image/icon_ LinearArrowDown.png") no-repeat center / 8px;
            }

            .up {
                background: url("../../assets/image/icon_ LinearArrowDown.png") no-repeat center / 8px;
                transform: rotate(180deg);
            }
        }
    }

    .moduleInfo {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        .moduleItem {
            color: rgba(255, 255, 255, 0.6);
            text-align: center;

            img {
                width: 48px;
                height: 48px;
                opacity: 0.8;
            }

            p {
                margin-top: -3px;
                font-size: 12px;
            }
        }
    }

    .inquiryList {
        margin-top: 20px;

        .listLabel {
            margin-bottom: 12px;
            color: rgba(255, 255, 255, 0.9);
            display: flex;
            justify-content: space-between;
        }

        .inquiryGrid {
            width: 100%;
        }

        .listItem {
            margin-bottom: 4px;
            height: 56px;
            background: rgba(255, 255, 255, 0.05);
            color: rgba(255, 255, 255, 0.9);
            display: flex;
            justify-content: space-between;
            align-items: center;

            .lose {
                color: #d53749 !important;
            }

            .heroInfo {
                flex: 0.36;

                display: flex;
                height: 56px;
                background: url("../../assets/image/green.png");
                background-repeat: no-repeat;
                background-position: left;
                background-size: 75px 56px;
                align-items: center;
                font-size: 12px;

                // min-width: 126px;

                &.failed {
                    background: url("../../assets/image/red.png");
                    background-repeat: no-repeat;
                    background-position: left;
                    background-size: 75px 56px;
                }

                &.tie {
                    background: url("../../assets/image/yellow.png");
                    background-repeat: no-repeat;
                    background-position: left;
                    background-size: 75px 56px;
                }

                img {
                    margin: 8px 7px 8px 12px;
                    width: 40px;
                    height: 40px;
                    min-width: 40px;
                }

                .endTime {
                    margin-top: 5px;
                    font-size: 10px;
                    color: rgba(255, 255, 255, 0.6);
                }

                .hero {
                    width: 60px;

                    position: relative;
                    top: 1px;

                    p {
                        white-space: nowrap;
                        /* 不换行 */
                        overflow: hidden;
                        /* 超出隐藏 */
                        text-overflow: ellipsis;
                        /* 显示省略号 */
                    }
                }
            }

            .scoreInfo {
                // min-width: 49px;
                flex: 0.16;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                // font-weight: bold;
                // padding-left: 13px;

                position: relative;
                top: 1px;

                p {
                    color: rgba(255, 255, 255, 0.6);
                    font-size: 12px;

                    span {
                        color: #d53749;
                    }

                    .lose {
                        color: #0ab99f !important;
                    }
                }

                div {
                    margin-top: 5px;
                    // padding: 0 8px;
                    font-size: 10px;
                    color: #9cabbd;
                    background: #293746;
                    border-radius: 7px;
                    height: 14px;
                    box-sizing: border-box;
                    text-align: center;
                    width: 34px;
                    font-weight: 700;

                    &.mvp {
                        background: #cbb765;
                        color: #222;
                    }

                    &.second {
                        background: #8e91a7 !important;
                        color: #222 !important;
                    }

                    &.third {
                        background: #a86243;
                        color: #222;
                    }
                }
            }

            .mapInfo {
                flex: 0.24;

                // min-width: 84px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 12px;
                // font-weight: bold;

                position: relative;
                top: 1px;

                .gameMode {
                    margin-top: 5px;
                    font-size: 10px;
                    color: rgba(255, 255, 255, 0.4);
                    font-weight: normal;
                }

                p,
                div {
                    max-width: 60px;
                    white-space: nowrap;
                    /* 不换行 */
                    overflow: hidden;
                    /* 超出隐藏 */
                    text-overflow: ellipsis;
                }
            }

            .resultInfo {
                flex: 0.24;

                // min-width: 84px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                // padding-right: 16px;
                font-size: 12px;
                // font-weight: bold;

                position: relative;
                top: 1px;

                div {
                    margin-top: 5px;
                    font-size: 10px;
                    color: rgba(255, 255, 255, 0.4);
                    font-weight: normal;

                    span {
                        margin-right: 4px;
                        color: #0ab99f;
                    }
                }
            }
        }

        .allInquiry {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.6);

            i {
                margin-left: 2px;
                display: inline-block;
                width: 10px;
                height: 10px;
                background: url("../../assets/image/icon_\ LinearArrowDown.png") no-repeat center / 10px;
                transform: rotate(270deg);
            }
        }

        .noData {
            width: 100%;
            height: 300px;
            background: url("../../assets/image/icon_PageWuNeiRong.png") no-repeat center / 200px 170px;
        }
    }

    .filterWeapon {
        color: #d7d7d9;
        padding: 17px 0px 5px;

        .popupTitle {
            font-size: 15px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-weight: bold;
            line-height: 22px;
            padding: 0 16px;
            margin-bottom: 5px;

            .addIcon {
                font-size: 13px;
                color: #717173;

                i {
                    display: inline-block;
                    margin-right: 4px;
                    width: 10px;
                    height: 10px;
                    background: url("../../assets/image/icon_add.png") no-repeat center / 10px;
                }
            }
        }

        .popupBody {
            margin-top: -3px;
            padding-bottom: 30px;
            max-height: 413px;
            overflow: scroll;
            box-sizing: border-box;
        }

        .weaponBox {
            &:first-child {
                .weaponType {
                    margin-top: 16px;
                }
            }
        }

        .weaponType {
            margin-top: 19px;
            font-size: 12px;
            color: #717173;
            line-height: 16px;
        }

        .weaponsList {
            padding: 0 16px;
        }

        .weapons {
            margin-top: 11px;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 8px;

            .weaponMenu {
                height: 36px;
                border-radius: 2px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                overflow: hidden;
                font-size: 12px;
                color: #b1b1b5;
                line-height: 28px;
                transition: all 0.2s;
                overflow: hidden;
                text-overflow: ellipsis;
                box-sizing: border-box;

                &.cur {
                    color: #222226;
                }

                span {
                    margin-left: 8px;
                    display: inline-block;
                    color: #717173;
                    font-size: 12px;
                    background-color: #2e2e33;
                    padding: 2px 5px;
                    line-height: 17px;
                    border-radius: 3px;
                }

                i {
                    width: 18px;
                    height: 18px;
                    display: inline-block;
                    background: url("../../assets/image/icon_DuiGou_18x18_Red.png") no-repeat center / 18px;
                }
            }
        }
    }
}

.noDataValue {
    color: rgba(255, 255, 255, 0.5) !important;
}

@keyframes rotate {
    from {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    to {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}
</style>
